import {Component, Input, OnInit} from '@angular/core';
import {User} from '../../../../lib/user.service';
import {QueryFieldModel} from '../../../../util/core-utils';
import {OrderType, QueryResult} from '../../../../lib/util/services';
import {CustomerRecord, CustomerRecordService} from '../../../../lib/customer/customer-record.service';
import {Set} from 'immutable';
import {RightResolver, RightService} from "../../../../lib/right.service";
import {RightModel} from "../../../../app.rights";
import {
  CustomerRecordOwnerModifyDialogComponent
} from "../customer-record-owner-modify-dialog/customer-record-owner-modify-dialog.component";
import {MatDialog} from "@angular/material/dialog";
import {UIRouter} from "@uirouter/angular";


@Component({
  selector: 'app-customer-record-owner-user-list',
  templateUrl: './customer-record-owner-user-list.component.html',
  styleUrls: ['./customer-record-owner-user-list.component.scss']
})
export class CustomerRecordOwnerUserListComponent implements OnInit {

  User = User;

  pagingId = 'customerRecordOwnerUserList';

  @Input()
  customerId: number;

  @Input()
  customerRecordId: number;

  @Input()
  readonly: boolean = true;


  queryModel: QueryFieldModel<User.OrderField> =
    new QueryFieldModel(User.OrderField.PERSON_NAME, OrderType.ASC);

  userList: CustomerRecord.OwnerUserData[] = [];

  @Input()
  rightModel: RightModel = RightModel.empty();

  constructor(private customerRecordService: CustomerRecordService,
              private dialog: MatDialog,
              private router: UIRouter) {
  }

  ngOnInit(): void {
  }

  initComponent() {
    this.loadList();
  }

  loadList(pageNumber?: number) {
    const requestedPage = pageNumber ? pageNumber : this.queryModel.currentPage;
    const order = this.queryModel.getOrder();
    this.customerRecordService.queryOwnerUsers({
      customerId: this.customerId,
      customerRecordId: this.customerRecordId,
      orders: Set.of(order),
      paging: requestedPage ? {
        pageNumber: requestedPage,
        numberOfItems: this.queryModel.itemsPerPage
      } : undefined,
      fields: Set.of('id', 'person_name', 'user_name', 'disabled')
    }).subscribe((result: QueryResult<CustomerRecord.OwnerUserData>) => {
      this.userList = result.items.toArray();
      this.queryModel.currentPage = requestedPage;
      this.queryModel.totalNumberOfItems = result.pagingResult.totalNumberOfItems;
      this.queryModel.currentNumberOfItems = result.pagingResult.currentNumberOfItems;
    });
  }

  orderBy(field: User.OrderField) {
    this.queryModel.onOrderFieldChanged(field);
    this.loadList(1);
  }

  pageChanged(selectedPage: number) {
    this.loadList(selectedPage);
  }

  itemsPerPageChanged(itemsPerPage: number) {
    this.queryModel.itemsPerPage = itemsPerPage;
    this.loadList(1);
  }

  ownerUserAddClicked() {
    CustomerRecordOwnerModifyDialogComponent.openDialog(this.dialog,
      {
        customerRecordIds: [this.customerRecordId],
        allowUserChange: true,
        allowUserGroupChange: false
      }, (result) => {
        if (result && result.success) {
          this.loadList();
        }
      });
  }

  userDeleteClicked(user: CustomerRecord.OwnerUserData) {
    this.customerRecordService.changeOwners({
      customerRecordIds: Set.of(this.customerRecordId),
      ownerUserIds: Set.of(user.id),
      changeType: 'DELETE'
    }).subscribe(result => {
      this.loadList();
    });
  }
}
